// ==============================|| OVERRIDES - SVG ICON (AUTOMATIC DASHBOARD STYLING) ||============================== //

export default function SvgIcon(theme) {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // Automatically style large icons (fontSize 3rem or larger) with circular background
          // This targets dashboard icons without needing manual className
          '&.MuiSvgIcon-fontSizeLarge': {
            fontSize: '3rem',
            padding: '15px',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: 'rgba(227, 242, 253, 0.8)',
            color: theme.palette.primary.main,
            display: 'block',
            margin: '0 auto',
            marginBottom: theme.spacing(2),
            transition: 'all 0.3s ease-in-out',
            boxSizing: 'content-box',
            
            '&:hover': {
              backgroundColor: 'rgba(144, 202, 249, 0.5)',
              transform: 'scale(1.05)'
            }
          },
          
          // Also target icons with inline style fontSize 3rem (for existing code)
          '&[style*="font-size: 3rem"], &[style*="fontSize: 3rem"]': {
            padding: '15px',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: 'rgba(227, 242, 253, 0.8)',
            color: theme.palette.primary.main,
            display: 'block',
            margin: '0 auto',
            marginBottom: theme.spacing(2),
            transition: 'all 0.3s ease-in-out',
            boxSizing: 'content-box',
            
            '&:hover': {
              backgroundColor: 'rgba(144, 202, 249, 0.5)',
              transform: 'scale(1.05)'
            }
          }
        }
      }
    }
  };
}
